import { ChannelAdminsState } from './types';

export const initialState: ChannelAdminsState = {
  admins: [],
  adminContacts: [],
  temporarilyLockedEmails: {},
  workingPermissions: null,
  unlockingEmail: false,
  activeChannelProducersAndPresenters: null,
};
